import React from "react";
import '../../css/Toggle.css';

const Toggle = ({ label, checked, onChange, isRequired = false }) => {
  return (
    <div className="toggleWrapper">
      <span className="toggleLabel">{label}</span>
      <label className="toggleSwitch">
        <input
          type="checkbox"
          className="toggleInput"
          checked={checked}
          onChange={onChange}
          required={isRequired}
        />
        <span className="toggleSlider"></span>
      </label>
    </div>
  );
};

export default Toggle;
